let new_edd_days = document.querySelector('.new_edd_days');
let new_edd_pin_input = document.querySelector('.new_edd_pin_input');
let new_edd_error_div = document.querySelector('.new_edd_error_div');
let default_variant_new_edd_detail = document.querySelector('.default_variant_new_edd_detail');
let stiching_inputs = document.querySelectorAll('.pdp-addonbox-wrap .tab-header-button input');

window.return_new_eddd_date_based_on_type = function(fun_calling_place,RTS,MTO,variant_edd_type) {
    if(fun_calling_place == 'product'){
        if(variant_edd_type == 'RTS'){
            let blouse_stiched = document.querySelector('#blouse-stitching:checked');
            if(blouse_stiched){
                RTS = parseFloat(RTS) + 4;
            }
        }
    }
    let new_edd_date_span = document.querySelector('.new_edd_date_span');
    let new_edd_days = document.querySelector('.new_edd_days');
    let days = 0;
    let date = new Date();

    if (variant_edd_type == "RTS") {
        days = Number(RTS);

        while (days > 0) {
            date.setDate(date.getDate() + 1);
            if (date.getDay() !== 0) days--;
        }
    } else if (variant_edd_type == "MTO") {
        days = Number(MTO);
        date.setDate(date.getDate() + days);
    }

    let result_date = date.toLocaleDateString("en-GB", {
        weekday: "long",
        day: "2-digit",
        month: "short",
        year: "numeric"
    }); 

    if (fun_calling_place == 'product' && new_edd_date_span) new_edd_date_span.innerHTML = result_date;
    if(fun_calling_place == 'product'){
        let edd_product_property = document.querySelector('.edd_product_property');
        edd_product_property.value = result_date;
    }

    return result_date;
};
 

window.return_new_eddd_date_main = function () {
  let has_product_variant = document.querySelector('.pro_var_input_e');
  if(!new_edd_days)return;
  if(has_product_variant){
    let selected_variant = document.querySelector('.pro_var_input_e:checked');
    if(selected_variant){
      return_new_eddd_date_based_on_type('product',new_edd_days.dataset.rts,new_edd_days.dataset.mto,selected_variant.dataset.new_edd_pro_type);
    }else{//take FIRST RTS if available
        let first_rts_variant = document.querySelector('.pro_var_input_e[data-new_edd_pro_type="RTS"]');
        let first_mto_variant = document.querySelector('.pro_var_input_e[data-new_edd_pro_type="MTO"]');
        if(first_rts_variant){
            return_new_eddd_date_based_on_type('product',new_edd_days.dataset.rts,new_edd_days.dataset.mto,'RTS');
        }else if(first_mto_variant){
            return_new_eddd_date_based_on_type('product',new_edd_days.dataset.rts,new_edd_days.dataset.mto,'MTO');
        }else{
            return_new_eddd_date_based_on_type('product',new_edd_days.dataset.rts,new_edd_days.dataset.mto,'SOLDOUT');
        }
    }
  }else{
   return_new_eddd_date_based_on_type('product',new_edd_days.dataset.rts,new_edd_days.dataset.mto,default_variant_new_edd_detail.dataset.new_edd_pro_type);
  }
};



window.new_update_cart_edd = async function () {
  const cart_items = document.querySelectorAll(".cart-drawer__items .line-item");
  const need_to_update_items = [];

  cart_items.forEach((cart_item) => {
    const current_edd = cart_item.dataset.edd;
    const variant_id = cart_item.dataset.variant_id;
    const line_key = cart_item.dataset.lineKey;
    let new_edd_pro_type = cart_item.dataset.new_edd_pro_type;
    let product_rts = Number(cart_item.dataset.product_rts);
    let product_mto = Number(cart_item.dataset.product_mto);
    let has_blouse_stiched = cart_item.querySelector('.bundle-item__title[data-addon_title="Blouse Stitching"]');

    if (has_blouse_stiched && new_edd_pro_type == 'RTS') {
      product_rts = product_rts + 4;
    }

    const latest_edd_date = return_new_eddd_date_based_on_type(
      'cart_item',
      product_rts,
      product_mto,
      new_edd_pro_type
    );

    if (current_edd && current_edd != latest_edd_date) {
      need_to_update_items.push({
        line_key,
        variant_id,
        new_edd: latest_edd_date
      });
    }
  });

  if (!need_to_update_items.length) return;

  let updated_count = 0;
  const total_update_count = need_to_update_items.length;

  for (const item of need_to_update_items) {
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: item.line_key,
          properties: {
            "Estimated Delivery": item.new_edd
          }
        })
      });

      if (!response.ok) {
        throw new Error(`Failed to update ${item.variant_id}`);
      }

      updated_count++;
    } catch (error) {
      console.error("EDD update failed:", item.variant_id, error);
    }
  }

  if (updated_count === total_update_count) {
    if (__st.p == 'cart') {
      window.location.reload();
    } else {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }
  }

  if(typeof iWish.checkIwishColl == 'function'){
    iWish.checkIwishColl();
  }
};


window.wishlist_drawer_edd = async function () {
  let  wishlist_item_grids = document.querySelectorAll('.iwishProduct-row');
  if(!wishlist_item_grids.length)return;
  for (const wishlist_item_grid of wishlist_item_grids) {
    let grid_wishlist_edd_date = wishlist_item_grid.querySelector('.wishlist_edd_date');
    if(!grid_wishlist_edd_date){
    let wishlist_pro_handle = wishlist_item_grid.querySelector('[data-handle]')?.dataset.handle;
    let wishlist_pro_variant_id = wishlist_item_grid.id.replace('product_var', '');

    try {
      const response = await fetch(`/products/${wishlist_pro_handle}`);
      const product_page_html_response = await response.text();
      const parser = new DOMParser();
      const product_page_html = parser.parseFromString(product_page_html_response, 'text/html');
      let product_variant_input = product_page_html.querySelector(`.pro_var_input.pro_var_input_e[data-variant_id="${wishlist_pro_variant_id}"]`);
      let new_edd_days = product_page_html.querySelector('.new_edd_days');
      let edd_span = document.createElement('span');
      edd_span.classList.add('wishlist_edd_date');

      if (product_variant_input) {
          let edd_pro_type = product_variant_input.dataset.new_edd_pro_type;
          edd_span.textContent = return_new_eddd_date_based_on_type('wishlist', new_edd_days.dataset.rts, new_edd_days.dataset.mto, edd_pro_type);
      } else {
          let edd_pro_type = product_page_html.querySelector('.default_variant_new_edd_detail').dataset.new_edd_pro_type;
          edd_span.textContent = return_new_eddd_date_based_on_type('wishlist', new_edd_days.dataset.rts, new_edd_days.dataset.mto, edd_pro_type);
      }

      let edd_wrapper = document.createElement('span');
      edd_wrapper.innerHTML = '<span class="new_edd_check_icon">✓</span>Estimated Delivery on ';
      edd_wrapper.appendChild(edd_span);
      wishlist_item_grid.querySelector('.iwish-cartQty').insertAdjacentElement('afterend', edd_wrapper);

    } catch (error) {
      console.error('Wishlist EDD error:', error)
    } finally {
      // product.dataset.eddLoading = 'false'
    }
   }
  }
}


function attach_atc_event() {
  document.addEventListener(
    'click',
    async function (event) {
      const singleBtn = event.target.closest('.iwish-cartQty .add_to_cart');
      const addAllBtn = event.target.closest('.addToCart-btn');

      if (!singleBtn && !addAllBtn) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      /*
       * ADD SINGLE PRODUCT
       */
      if (singleBtn) {
        const row = singleBtn.closest('.iwishProduct-row');

        if (!row) return;

        const variantId = (row.id || '').replace('product_var', '');

        if (!variantId || !/^\d+$/.test(variantId)) {
          console.error('Variant ID not found');
          return;
        }

        const eddElement = row.querySelector('.wishlist_edd_date');

        let edd = eddElement.innerText.trim();

        const btnText = singleBtn.querySelector('span');
        const originalText = btnText?.textContent || 'Add To Cart';

        singleBtn.disabled = true;

        if (btnText) {
          btnText.textContent = 'Adding...';
        } else {
          singleBtn.textContent = 'Adding...';
        }

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: Number(variantId),
                  quantity: 1,
                  properties: {
                    "Estimated Delivery": edd
                  }
                }
              ]
            })
          });

          if (!response.ok) {
            throw new Error('Failed to add product');
          }

          const data = await response.json();

          if (btnText) {
            btnText.textContent = 'Added';
          } else {
            singleBtn.textContent = 'Added';
          }

          document.dispatchEvent(new CustomEvent("cart:refresh"));

          setTimeout(() => {
            if (btnText) {
              btnText.textContent = originalText;
            } else {
              singleBtn.textContent = originalText;
            }

            singleBtn.disabled = false;
          }, 2000);

        } catch (error) {
          console.error('Add to cart error:', error);

          if (btnText) {
            btnText.textContent = originalText;
          } else {
            singleBtn.textContent = originalText;
          }
          singleBtn.disabled = false;
        }
        return;
      }

      /*
       * ADD ALL PRODUCTS
       */
      if (addAllBtn) {
        const rows = document.querySelectorAll(
          '.iwish-row.iwishProduct-row'
        );

        if (!rows.length) {
          console.error('No wishlist products found');
          return;
        }

        const items = [];

        rows.forEach((row) => {
          const variantId = (row.id || '').replace('product_var', '');

          if (!variantId || !/^\d+$/.test(variantId)) {
            return;
          }

          const eddElement = row.querySelector('.wishlist_edd_date');

          let edd = eddElement.innerText.trim();

          items.push({
            id: Number(variantId),
            quantity: 1,
            properties: {
              "Estimated Delivery": edd
            }
          });
        });

        if (!items.length) {
          console.error('No valid products found');
          return;
        }

        const originalText = addAllBtn.textContent.trim();

        addAllBtn.disabled = true;
        addAllBtn.textContent = 'Adding...';

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: items
            })
          });

          if (!response.ok) {
            throw new Error('Failed to add products');
          }

          const data = await response.json();

          console.log('All wishlist products added:', data);

          addAllBtn.textContent = 'Added to cart';

          document.dispatchEvent(new CustomEvent("cart:refresh"));

          setTimeout(() => {
            addAllBtn.textContent = originalText;
            addAllBtn.disabled = false;
          }, 2000);

        } catch (error) {
          console.error('Add all to cart error:', error);

          addAllBtn.textContent = originalText;
          addAllBtn.disabled = false;
        }
      }
    },
    true
  );
}


// calling events start below

return_new_eddd_date_main();

document.addEventListener('variant:change', function(event) {
    return_new_eddd_date_main();
    setTimeout(() => {
       return_new_eddd_date_main();
    }, 1000);
});

document.querySelector('.new_edd_check_button')?.addEventListener('click', () => {
    let pincode = new_edd_pin_input?.value.trim() || '';
    new_edd_error_div.textContent = '';

    if (!pincode) {
        new_edd_error_div.textContent = 'Please enter your PIN code.';
        return;
    }

    if (!/^[1-9][0-9]{5}$/.test(pincode)) {
        new_edd_error_div.textContent = 'Please enter a valid 6-digit Indian PIN code.';
        return;
    }

    return_new_eddd_date_main();
});


let new_edd_pin_timer;

new_edd_pin_input?.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
        event.preventDefault();
        clearTimeout(new_edd_pin_timer);

        let pincode = new_edd_pin_input.value.trim();

        if (!/^[1-9][0-9]{5}$/.test(pincode)) {
            new_edd_error_div.textContent = pincode
                ? 'Please enter a valid 6-digit Indian PIN code.'
                : 'Please enter your PIN code.';
            return;
        }

        new_edd_error_div.textContent = '';
        return_new_eddd_date_main();
    }
});


if(stiching_inputs.length){
    stiching_inputs.forEach((stiching_input)=>{
        stiching_input.addEventListener('change',()=>{
          return_new_eddd_date_main();
        })
    })
}


function drawerInitCallback() {
    let count = 0;
    const interval = setInterval(() => {
        const wishlistProducts = document.querySelectorAll(".iwishProduct-row");
        if (wishlistProducts.length) {
            clearInterval(interval);
            wishlist_drawer_edd();
            attach_atc_event();
        }
        if (++count > 20) {
            clearInterval(interval);
        }
    }, 500);
}